module.exports = __webpack_public_path__ + "img/7fefb1b224c75bc07864207047f2443f.7fefb1b2.png";